// services/categorieService.ts
import axios from "axios";
import { MAIN_API_URL } from "../config/api";
import { Categorie, BaseCategorie } from "../types/features/Post";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const categorieService = {
  // 🔓 PUBLIC - Pas de token nécessaire
  async getAll(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Categorie>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/blog/categories`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des catégories", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire
  async getById(id: string): Promise<Categorie> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/blog/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de la catégorie", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async create(token: string, data: BaseCategorie): Promise<Categorie> {
    try {
      const slug = data.name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");

      const response = await axios.post(`${MAIN_API_URL}/blog/categories`, {
        ...data,
        product_name: data.product_name || 'all',
        slug,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de la catégorie", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: Partial<BaseCategorie>): Promise<Categorie> {
    try {
      const payload = { ...data };
      if (data.name) {
        payload.slug = data.name
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "");
      }
      const response = await axios.put(`${MAIN_API_URL}/blog/categories/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la catégorie", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/blog/categories/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de la catégorie", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      const promises = ids.map((id) => this.delete(token, id));
      await Promise.all(promises);
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },
};